import React from "react";

/**
 * แถบตัวเลขสรุปเหนือตารางของระบบ CMRU ใช้ร่วมกันทั้งหน้ารายการกลุ่มเรียน แท็บรายชื่อ และแท็บเช็คชื่อ
 * items: [tone, icon, value, label, hint?] · tone = green | gold | blue | violet | pink | red
 * tight: บนมือถือเรียง 4 ใบในแถวเดียวและซ่อนไอคอน ใช้กับแท็บเช็คชื่อที่ต้องเหลือที่ให้ตารางมากที่สุด
 * compact: ใบเล็กกว้างตามเนื้อหา เรียงชิดซ้ายในแถวเดียว ใช้เมื่อมีแค่ 2-3 ใบ จะได้ไม่เหลือช่องว่างและไม่กินพื้นที่
 */
export default function KpiStrip({ items, tight = false, compact = false }) {
  return (
    <div className={["cmru-kpis mb-3", tight ? "cmru-kpis--tight" : "", compact ? "cmru-kpis--compact" : ""].join(" ").trim()}>
      {items.map(([tone, icon, value, label, hint]) => (
        <div key={label} className={`cmru-kpi cmru-kpi--${tone}`} title={hint}>
          <span className="cmru-kpi-icon"><i className={icon} /></span>
          <div style={{ minWidth: 0 }}>
            <div className="cmru-kpi-value">{typeof value === "number" ? value.toLocaleString() : value}</div>
            <div className="cmru-kpi-label">{label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
